
<template>
  <div class="legend-card">
    <label class="form-label">Equipment Type</label>
    <div class="chart-legend">
      <div
      v-for="item in items"
      :key="item.label"
      class="legend-item"
      >
      <span
          class="legend-swatch"
          :style="{ backgroundColor: item.color }"
      ></span>
      <span>{{ item.label }}</span>
      </div>
    </div>
  </div>
</template>

<script setup>
defineProps({
  items: { type: Array, default: () => [] },
})
</script>

<style scoped>
.legend-card {
  margin-top: 1rem;
}

.legend-title {
  font-size: 1rem;
  font-weight: 700;
  margin-bottom: 0.25rem;
  color: var(--color-primary-dark); 
}

.chart-legend {
  display: flex;
  flex-wrap: wrap;
  gap: 0.1rem 0.6rem;
  margin: 0rem 0 1rem;
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 0.3rem;
  font-size: 0.7rem;
}

.legend-swatch {
  width: 0.7rem;
  height: 0.7rem;
  border-radius: 2px;
  flex: 0 0 auto;
}
</style>